/* eslint-disable react/prop-types,no-unused-vars */
import React from 'react';
import * as _ from 'lodash';
import { is } from 'immutable';
import {
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepCancellationAdditionalExpenseLookup,
  stepOtherExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepBaggageAndPersonalLookup,
  stepMedicalExpenseCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  stepTravelDelayLookup,
  stepMedicalAndEvacuationLookup,
  stepChangesToYourJourneyLookup,
  stepBaggageAndPersonalItemsSCTILookup,
  stepPersonalAccidentSCTILookup,
  stepRentalVehicleExcessSCTILookup,
  stepCashBankCardsTravelDocumentsAndPassportsLookup,
  stepChangesToYourJourneyTrawickLookup,
  stepBaggageAndPersonalItemsStarrLookup,
  stepOtherStarrLookup,
  stepCollisionDamageStarrLookup,
  stepMedicalExpensesTugoLookup,
  stepOtherTugoLookup,
  stepBaseVictorsMedicalTugoLookup,
  stepStudentMedicalBenefitsTugoLookup,
  stepTripInterruptionTugoLookup,
  stepTripCancellationTugoLookup,
  stepTripCancellationTravellerTugoLookup,
  stepTripInterruptionTravellerTugoLookup,
  stepStandardVTCMedicalBenefitsTugoLookup,
  stepTravellerMedicalBenefitsTugoLookup,
  stepOptimumMedicalBenefitsTugoLookup,
  stepADAndDTugoLookup,
  stepADAndDTravellerTugoLookup,
  stepBaggageAndPersonalItemsTravellerTugoLookup,
  stepRentalCarProtectionTravellerTugoLookup,
} from '../../../dataMapper/claimCodeMapper';
import stepOtherExpenseMapper from '../../../dataMapper/stepOtherDataMapper';
import stepTripCancellationAndTripInterruptionExpenseMapper from '../../../dataMapper/stepTripCancellationAndTripInterruption';
import stepBaggageAndPersonalItemsExpenseMapper from '../../../dataMapper/stepBaggageAndPersonalItemsDataMapper';
import stepMedicalExpensesExpenseMapper from '../../../dataMapper/stepMedicalExpensesDataMapper';
import stepMedicalExpenseMapper from '../../../dataMapper/stepMedicalExpenseDataMapper';
import stepTripCancellationMapper from '../../../dataMapper/stepTripCancellationDataMapper';
import stepTripDelayDataMapper from '../../../dataMapper/stepTripDelayDataMapper';
import stepTripInterruptionDataMapper from '../../../dataMapper/stepTripInterruptionDataMapper';
import stepPetMedicalMapper from '../../../dataMapper/stepPetMedicalDataMapper';
import stepCollisionDamageDataMapper from '../../../dataMapper/stepCollisionDamageDataMapper';
import stepPropertyDamageDataMapper from '../../../dataMapper/stepPropertyDamageDataMapper';
import stepMissedConnectionDataMapper from '../../../dataMapper/stepMissedConnectionDataMapper';
import stepPersonalItemDataMapper from '../../../dataMapper/stepPersonalItemDataMapper';
import stepMedicalExpenseCFDataMapper from '../../../dataMapper/stepMedicalExpenseCFDataMapper';
import stepMedicalExpenseZurichDataMapper from '../../../dataMapper/stepMedicalExpenseZurichDataMapper';
import stepItineraryChangeDataMapper from '../../../dataMapper/stepItineraryChangeDataMapper';
import stepBaggagePersonalEffectsDataMapper from '../../../dataMapper/stepBaggagePersonalEffectsDataMapper';
import stepTravelDelayDataMapper from '../../../dataMapper/stepTravelDelayDataMapper';
import stepMedicalAndEvacuationSCTIDataMapper from '../../../dataMapper/stepMedicalAndEvacuationSCTIDataMapper';
import stepChangesToYourJourneySCTIDataMapper from '../../../dataMapper/stepChangesToYourJourneySCTIDataMapper';
import stepBaggageAndPersonalItemsSCTIDataMapper from '../../../dataMapper/stepBaggageAndPersonalItemsSCTIDataMapper';
import stepCashBankCardsTravelDocumentsAndPassportsDataMapper from '../../../dataMapper/stepCashBankCardsTravelDocumentsAndPassportsDataMapper';
import stepPersonalAccidentSCTIDataMapper from '../../../dataMapper/stepPersonalAccidentSCTIDataMapper';
import stepRentalVehicleExcessSCTIDataMapper from '../../../dataMapper/stepRentalVehicleExcessSCTIDataMapper';
import stepChangesToYourJourneyDataMapper from '../../../dataMapper/stepChangesToYourJourneyDataMapper';
import stepBaggageAndPersonalItemsStarrDataMapper from '../../../dataMapper/stepBaggageAndPersonalItemsStarrDataMapper';
import stepOtherStarrDataMapper from '../../../dataMapper/stepOtherDataStarrMapper';
import stepCollisionDamageStarrDataMapper from '../../../dataMapper/stepCollisionDamageStarrDataMapper';
import stepMedicalExpensesTugoDataMapper from '../../../dataMapper/stepMedicalExpensesTugoDataMapper';
import stepOtherTugoDataMapper from '../../../dataMapper/stepOtherDataTugoMapper';
import stepBaseVictorsMedicalTugoMapper from '../../../dataMapper/stepBaseVictorsMedicalTugoDataMapper';
import stepStudentMedicalBenefitsTugoMapper from '../../../dataMapper/stepStudentMedicalBenefitsTugoDataMapper';
import stepStandardVTCMedicalBenefitsTugoMapper from '../../../dataMapper/stepStandardVTCMedicalBenefitsTugoDataMapper';
import stepTravellerMedicalBenefitsTugoMapper from '../../../dataMapper/stepTravellerMedicalBenefitsTugoDataMapper';
import stepOptimumMedicalBenefitsTugoMapper from '../../../dataMapper/stepOptimumMedicalBenefitsTugoDataMapper';
import stepTripCancellationTugoMapper from '../../../dataMapper/stepTripCancellationTugoDataMapper';
import stepTripCancellationTravellerTugoMapper from '../../../dataMapper/stepTripCancellationTravellerTugoDataMapper';
import stepTripInterruptionTugoMapper from '../../../dataMapper/stepTripInterruptionTugoDataMapper';
import stepTripInterruptionTravellerTugoMapper from '../../../dataMapper/stepTripInterruptionTravellerTugoDataMapper';
import stepADAndDTugoDataMapper from '../../../dataMapper/stepADAndDTugoDataMapper';
import stepADAndDTravellerTugoDataMapper from '../../../dataMapper/stepADAndDTravellerTugoDataMapper';
import stepBaggageAndPersonalItemsTravellerTugoDataMapper from '../../../dataMapper/stepBaggageAndPersonalItemsTravellerTugoDataMapper';
import stepRentalCarProtectionTravellerTugoDataMapper from '../../../dataMapper/stepRentalCarProtectionTravellerTugoDataMapper';
import { Table } from '../../../../../components/Table';
import TH from '../../../../../components/Table/TH';
import TR from '../../../../../components/Table/TR';
import TD from '../../../../../components/Table/TD';


const DocumentTableMultiInsureds = (props) => {
  const formatMessage = (id, defaultMessage) => (
    props.intl && props.intl.formatMessage
      ? props.intl.formatMessage({ id, defaultMessage })
      : defaultMessage
  );

  const renderIcon = (hasFile) => {
    if (hasFile) {
      return <i style={{ color: '#44b4a6' }} className="fa fa-check fa-2x" aria-hidden="true" />;
    }
    return <i style={{ color: 'orange' }} className="fa fa-times fa-2x" aria-hidden="true" />;
  };

  const checkProvided = (claimCodeList) => {
    const listDocuments = props.listDocuments || [];
    const attachDocuments = (props.stepSupportingDocumentsData && props.stepSupportingDocumentsData.attachDocuments) || [];

    // Find all items in listDocuments that match any of our codes OR have a parent in our codes
    const relevantItems = listDocuments.filter(item =>
      claimCodeList.includes(item.claimCode) || claimCodeList.includes(item.parentBenefitCode)
    );

    if (relevantItems.length === 0) {
      // Fallback: check if ANY document is attached for any of the codes (standard logic)
      return claimCodeList.some(code =>
        attachDocuments.some(doc => doc.benefitCode === code)
      );
    }

    let allMandatoryProvided = true;
    let anyMandatoryExists = false;

    relevantItems.forEach(item => {
      const requiredDocs = item.requiredDocuments || [];
      const mandatoryDocs = requiredDocs.filter(d => d.mandatory);

      if (mandatoryDocs.length > 0) {
        anyMandatoryExists = true;
        const allProvided = mandatoryDocs.every(m =>
          attachDocuments.some(doc => doc.requiredDocumentId === m.claimRequiredDocumentId)
        );
        if (!allProvided) {
          allMandatoryProvided = false;
        }
      }
    });

    if (anyMandatoryExists) {
      return allMandatoryProvided;
    }

    // If no mandatory docs defined, check if ANY document is provided for these items
    return relevantItems.some(item =>
      attachDocuments.some(doc => doc.benefitCode === item.claimCode)
    ) || claimCodeList.some(code => attachDocuments.some(doc => doc.benefitCode === code));
  };
  const claimantId = props.claimantId;
  const insuredsList = props.insuredsList;
  const { selectedBenefits, selectedClaimFor } = props.stepWhatHappenedData;
  const selectedClaimForList = selectedClaimFor ? selectedClaimFor.toJS ? selectedClaimFor.toJS() : selectedClaimFor : [];
  let selectedInsured = selectedClaimForList;
  if (selectedClaimForList.filter((x) => x.id === claimantId).length === 0) {
    const claimant = insuredsList.find((x) => x.id === claimantId);
    if (claimant) {
      selectedInsured = [...selectedClaimForList, claimant];
    }
  }
  const { attachDocuments } = props.stepSupportingDocumentsData;
  const { medicalExpenses } = props.stepOverseasMedicalData;
  const { lossInformationItems } = props.stepTripCancellationAndTripInterruptionData;
  const { descriptionOfItems, descriptionOfItemsForDamaged } = props.stepBaggageAndPersonalItemsData;
  const { additionalItems, delayedLuggageExpenses } = props.stepPersonalItemsData;
  // const stepMedicalExpensesData = props.stepMedicalExpensesData;
  const { cancellationExpenses, delayedTravelExpenses, additionalExpenses } = props.stepCancellationAdditionalData;
  const { bicyclePackOptionalExpensesClaimed, golfPackOptionalExpensesClaimed,
    personalLiabilitiesExpensesClaimed, areYouClaimingForPersonalLiability, anythingElseExpensesClaimed, isThereAnyThingElseYouWouldLikeToClaimFor,
    areYouClaimingForGolfPackOptionalCover, areYouClaimingForBicyclePackOptionalCover, areYouClaimingForAccidentalDeathAndDismemberment,
    areYouClaimingForBurialOrRepatriationExpenses, checkNameOfDeceases, causeOfDeath, amountClaimed } = props.stepOtherData;
  let stepOverseasMedicalAmount = 0;
  let stepPersonalItemsAmount = 0;
  let stepCancellationAdditionalAmount = 0;
  let stepTripCancellationAndTripInterruptionAmount = 0;
  let stepBaggageAndPersonalItemsAmount = 0;
  const stepRentalVehicleAmount = props.stepRentalVehicleData ? +props.stepRentalVehicleData.amountClaimed : 0;
  let stepOtherAmount = 0;
  let sum = 0;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function') ? selectedBenefits.toJS() : (selectedBenefits || []);
  const isStepPersonalItemsSelected = list.some((d) => stepPersonalItemsExpenseLookup.claimCodeList.includes(d.claimCode) || stepPersonalItemsExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepOverseasMedicalSelected = list.some((d) => stepOverseasMedicalExpenseLookup.claimCodeList.includes(d.claimCode) || stepOverseasMedicalExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepOtherSelected = list.some((d) => stepOtherExpenseLookup.claimCodeList.includes(d.claimCode) || stepOtherExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepCancellationAdditionalSelected = list.some((d) => stepCancellationAdditionalExpenseLookup.claimCodeList.includes(d.claimCode) || stepCancellationAdditionalExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepRentalVehicleSelected = list.some((d) => stepRentalVehicleExpenseLookup.claimCodeList.includes(d.claimCode) || stepRentalVehicleExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTripCancellationAndTripInterruptionSelected = list.some((d) => stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList.includes(d.claimCode) || stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaggageAndPersonalItemsSelected = list.some((d) => stepBaggageAndPersonalItemsExpenseLookup.claimCodeList.includes(d.claimCode) || stepBaggageAndPersonalItemsExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepMedicalExpensesSelected = !props.showZurichUHC && list.some((d) => stepMedicalExpensesExpenseLookup.claimCodeList.includes(d.claimCode) || stepMedicalExpensesExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepCollisionDamageSelected = list.some((d) => stepCollisionDamageExpenseLookup.claimCodeList.includes(d.claimCode) || stepCollisionDamageExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepPetMedicalSelected = list.some((d) => stepPetMedicalExpenseLookup.claimCodeList.includes(d.claimCode) || stepPetMedicalExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepPropertyDamageSelected = list.some((d) => stepPropertyDamageExpenseLookup.claimCodeList.includes(d.claimCode) || stepPropertyDamageExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTripCancellationSelected = list.some((d) => stepTripCancellationLookup.claimCodeList.includes(d.claimCode) || stepTripCancellationLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepMedicalExpenseSelected = list.some((d) => stepMedicalExpenseLookup.claimCodeList.includes(d.claimCode) || stepMedicalExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTripInterruptionSelected = list.some((d) => stepTripInterruptionLookup.claimCodeList.includes(d.claimCode) || stepTripInterruptionLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTripDelaySelected = list.some((d) => stepTripDelayLookup.claimCodeList.includes(d.claimCode) || stepTripDelayLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepMissedConnectionSelected = list.some((d) => stepMissedConnectionLookup.claimCodeList.includes(d.claimCode) || stepMissedConnectionLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepPersonalItemSelected = list.some((d) => stepBaggageAndPersonalLookup.claimCodeList.includes(d.claimCode) || stepBaggageAndPersonalLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepMedicalExpenseCFSelected = list.some((d) => stepMedicalExpenseCFLookup.claimCodeList.includes(d.claimCode) || stepMedicalExpenseCFLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepMedicalExpenseZurichSelected = props.showZurichUHC && list.some((d) => stepMedicalExpensesExpenseLookup.claimCodeList.includes(d.claimCode) || stepMedicalExpensesExpenseLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepItineraryChangeSelected = list.some((d) => itineraryChangeLookup.claimCodeList.includes(d.claimCode) || itineraryChangeLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaggagePersonalEffectsSelected = list.some((d) => baggagePersonalEffectsLookup.claimCodeList.includes(d.claimCode) || baggagePersonalEffectsLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTravelDelaySelected = list.some((d) => stepTravelDelayLookup.claimCodeList.includes(d.claimCode) || stepTravelDelayLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepMedicalAndEvacuationSelected = list.some((d) => stepMedicalAndEvacuationLookup.claimCodeList.includes(d.claimCode) || stepMedicalAndEvacuationLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepChangesToYourJourneySCTISelected = list.some((d) => stepChangesToYourJourneyLookup.claimCodeList.includes(d.claimCode) || stepChangesToYourJourneyLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaggageAndPersonalItemsSCTISelected = list.some((d) => stepBaggageAndPersonalItemsSCTILookup.claimCodeList.includes(d.claimCode) || stepBaggageAndPersonalItemsSCTILookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepCashBankCardsTravelDocumentsAndPassportsSelected = list.some((d) => stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList.includes(d.claimCode) || stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepPersonalAccidentSCTISelected = list.some((d) => stepPersonalAccidentSCTILookup.claimCodeList.includes(d.claimCode) || stepPersonalAccidentSCTILookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepRentalVehicleExcessSCTISelected = list.some((d) => stepRentalVehicleExcessSCTILookup.claimCodeList.includes(d.claimCode) || stepRentalVehicleExcessSCTILookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepChangesToYourJourneySelected = list.some((d) => stepChangesToYourJourneyTrawickLookup.claimCodeList.includes(d.claimCode) || stepChangesToYourJourneyTrawickLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaggageAndPersonalItemsStarrSelected = list.some((d) => stepBaggageAndPersonalItemsStarrLookup.claimCodeList.includes(d.claimCode) || stepBaggageAndPersonalItemsStarrLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepOtherStarrSelected = list.some((d) => stepOtherStarrLookup.claimCodeList.includes(d.claimCode) || stepOtherStarrLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepCollisionDamageStarrSelected = list.some((d) => stepCollisionDamageStarrLookup.claimCodeList.includes(d.claimCode) || stepCollisionDamageStarrLookup.claimCodeList.includes(d.parentBenefitCode));

  const isStepMedicalExpensesTugoSelected = list.some((d) => stepMedicalExpensesTugoLookup.claimCodeList.includes(d.claimCode) || stepMedicalExpensesTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepOtherTugoSelected = list.some((d) => stepOtherTugoLookup.claimCodeList.includes(d.claimCode) || stepOtherTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaseVictorsMedicalTugoSelected = list.some((d) => stepBaseVictorsMedicalTugoLookup.claimCodeList.includes(d.claimCode) || stepBaseVictorsMedicalTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepStudentMedicalBenefitsTugoSelected = list.some((d) => stepStudentMedicalBenefitsTugoLookup.claimCodeList.includes(d.claimCode) || stepStudentMedicalBenefitsTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepStandardVTCMedicalBenefitsTugoSelected = list.some((d) => stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList.includes(d.claimCode) || stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTravellerMedicalBenefitsTugoSelected = list.some((d) => stepTravellerMedicalBenefitsTugoLookup.claimCodeList.includes(d.claimCode) || stepTravellerMedicalBenefitsTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepOptimumMedicalBenefitsTugoSelected = list.some((d) => stepOptimumMedicalBenefitsTugoLookup.claimCodeList.includes(d.claimCode) || stepOptimumMedicalBenefitsTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepTripCancellationTugoSelected = list.some((d) =>
    stepTripCancellationTugoLookup.claimCodeList.includes(d.claimCode) ||
    stepTripCancellationTugoLookup.claimCodeList.includes(d.parentBenefitCode)
  );

  const isStepTripCancellationTravellerTugoSelected = list.some((d) =>
    stepTripCancellationTravellerTugoLookup.claimCodeList.includes(d.claimCode) ||
    stepTripCancellationTravellerTugoLookup.claimCodeList.includes(d.parentBenefitCode)
  );

  const hasEmbeddedTIExpenses = isStepTripCancellationTugoSelected
    && stepTripInterruptionTugoMapper.mapToExpenses(props.stepTripInterruptionTugoData || {}).length > 0;

  const isStepTripInterruptionTugoSelected = list.some((d) => stepTripInterruptionTugoLookup.claimCodeList.includes(d.claimCode) || stepTripInterruptionTugoLookup.claimCodeList.includes(d.parentBenefitCode))
    || hasEmbeddedTIExpenses;

  const hasEmbeddedTITravellerExpenses = isStepTripCancellationTravellerTugoSelected
    && (stepTripInterruptionTravellerTugoMapper.mapToExpenses(props.stepTripInterruptionTugoData || {}).length > 0
      || (props.stepTripCancellationTravellerTugoData && props.stepTripCancellationTravellerTugoData.changedAfterLeaving === 'yes'));

  const isStepTripInterruptionTravellerTugoSelected = list.some((d) => stepTripInterruptionTravellerTugoLookup.claimCodeList.includes(d.claimCode) || stepTripInterruptionTravellerTugoLookup.claimCodeList.includes(d.parentBenefitCode))
    || hasEmbeddedTITravellerExpenses;

  const isStepADAndDTugoSelected = list.some((d) => stepADAndDTugoLookup.claimCodeList.includes(d.claimCode) || stepADAndDTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepADAndDTravellerTugoSelected = list.some((d) => stepADAndDTravellerTugoLookup.claimCodeList.includes(d.claimCode) || stepADAndDTravellerTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepBaggageAndPersonalItemsTravellerTugoSelected = list.some((d) => stepBaggageAndPersonalItemsTravellerTugoLookup.claimCodeList.includes(d.claimCode) || stepBaggageAndPersonalItemsTravellerTugoLookup.claimCodeList.includes(d.parentBenefitCode));
  const isStepRentalCarProtectionTravellerTugoSelected = list.some((d) => stepRentalCarProtectionTravellerTugoLookup.claimCodeList.includes(d.claimCode) || stepRentalCarProtectionTravellerTugoLookup.claimCodeList.includes(d.parentBenefitCode));

  if (isStepCancellationAdditionalSelected && cancellationExpenses.length) {
    stepCancellationAdditionalAmount += _.sumBy(cancellationExpenses, (o) => +o.prePaidAmount);
  }
  if (isStepCancellationAdditionalSelected && delayedTravelExpenses.length) {
    stepCancellationAdditionalAmount += _.sumBy(delayedTravelExpenses, (o) => +o.amount);
  }

  if (isStepPersonalItemsSelected && additionalItems && additionalItems.length > 0) {
    stepPersonalItemsAmount += _.sumBy(additionalItems, (o) => +o.amountClaimed);
  }
  if (isStepPersonalItemsSelected && delayedLuggageExpenses && delayedLuggageExpenses.length > 0) {
    stepPersonalItemsAmount += _.sumBy(delayedLuggageExpenses, (o) => +o.amountClaimed);
  }

  if (isStepOverseasMedicalSelected && medicalExpenses && medicalExpenses.length > 0) {
    stepOverseasMedicalAmount = _.sumBy(medicalExpenses, (o) => +o.amountCharged);
  }
  if (areYouClaimingForBicyclePackOptionalCover === 'true' && bicyclePackOptionalExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(bicyclePackOptionalExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForGolfPackOptionalCover === 'true' && golfPackOptionalExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(golfPackOptionalExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForPersonalLiability === 'true' && personalLiabilitiesExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(personalLiabilitiesExpensesClaimed, (o) => +o.amount);
  }
  if (isThereAnyThingElseYouWouldLikeToClaimFor === 'true' && anythingElseExpensesClaimed.length) {
    stepOtherAmount += _.sumBy(anythingElseExpensesClaimed, (o) => +o.amount);
  }
  if (areYouClaimingForAccidentalDeathAndDismemberment === 'true' && !!checkNameOfDeceases) {
    stepOtherAmount += 0;
  }
  if (areYouClaimingForBurialOrRepatriationExpenses === 'true' && !!causeOfDeath) {
    stepOtherAmount += amountClaimed;
  }

  if (isStepTripCancellationAndTripInterruptionSelected && lossInformationItems.length) {
    stepTripCancellationAndTripInterruptionAmount += _.sumBy(lossInformationItems, (o) => +o.amountPaidLoss);
  }

  if (isStepBaggageAndPersonalItemsSelected && descriptionOfItems.length) {
    stepBaggageAndPersonalItemsAmount += _.sumBy(descriptionOfItems, (o) => +o.howMuch);
  }

  if (isStepBaggageAndPersonalItemsSelected && descriptionOfItemsForDamaged.length) {
    stepBaggageAndPersonalItemsAmount += _.sumBy(descriptionOfItemsForDamaged, (o) => +o.howMuch);
  }

  sum = stepCancellationAdditionalAmount + stepPersonalItemsAmount + stepOverseasMedicalAmount + stepRentalVehicleAmount + stepOtherAmount + stepTripCancellationAndTripInterruptionAmount + stepBaggageAndPersonalItemsAmount;
  const renderStepOverseasMedical = () => (
    medicalExpenses.map((x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={medicalExpenses.length}>{formatMessage('fastCover.DocumentTable.medical', 'Medical')}</TD>}
        <TD className={`${idx === medicalExpenses.length - 1 ? 'document-table-bottom document-table-right align-middle' : 'align-middle document-table-right'}`}>{x.nameOfDoctorOrProvider} | {x.treatmentReceived}</TD>
        <TD className={`${idx === medicalExpenses.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.amountCharged ? (+x.amountCharged).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === medicalExpenses.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={medicalExpenses.length} > {renderIcon(checkProvided(stepOverseasMedicalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    ))
  );

  const renderStepPersonalItems = () => {
    const data = additionalItems.concat(delayedLuggageExpenses);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.personalItems', 'Personal Items')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.amountClaimed ? (+x.amountClaimed).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.amountClaimedCurrency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}>{renderIcon(checkProvided(stepPersonalItemsExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepCancellationAdditional = () => {
    const additionalMapper = additionalExpenses.map((x) => ({
      description: `${x.supplier} | ${x.description}`,
      amount: x.amountPaid,
      currency: x.amountPaidCurrency,
    }));
    const delayedTravelExpensesMapper = delayedTravelExpenses.map((x) => ({
      description: x.description,
      amount: x.amount,
      currency: x.amountCurrency,
    }));
    const cancellationExpensesMapper = cancellationExpenses.map((x) => ({
      description: `${x.supplier} | ${x.cancelledBookingDescription}`,
      amount: x.prePaidAmount,
      currency: x.prePaidAmountCurrency,
    }));
    const data = additionalMapper.concat(delayedTravelExpensesMapper, cancellationExpensesMapper);

    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.tripInterruptionAndTravelDelay', 'Trip Interruption and Travel Delay')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.amount ? (+x.amount).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCancellationAdditionalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepOther = () => {
    const data = stepOtherExpenseMapper.mapToExpenses(props.stepOtherData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-top document-table-left document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.other', 'Other')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-top document-table-right" rowSpan={data.length}> {renderIcon(checkProvided(stepOtherExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepTripCancellationAndTripInterruption = () => {
    const data = stepTripCancellationAndTripInterruptionExpenseMapper.mapToExpenses(props.stepTripCancellationAndTripInterruptionData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.tripCancellationAndTripInterruption', 'Trip Cancellation & Trip Interruption')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepBaggageAndPersonalItems = () => {
    const data = stepBaggageAndPersonalItemsExpenseMapper.mapToExpenses(props.stepBaggageAndPersonalItemsData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.stepWhatHappened.baggageAndPersonalItems', 'Baggage and Personal Items')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}>{renderIcon(checkProvided(stepBaggageAndPersonalItemsExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepMedicalExpenses = () => {
    const data = stepMedicalExpensesExpenseMapper.mapToExpenses(props.stepMedicalExpensesData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.medicalExpenses', 'Medical Expenses')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}>{renderIcon(checkProvided(stepMedicalExpensesExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepCollisionDamage = () => {
    const data = stepCollisionDamageDataMapper.mapToExpenses(props.stepCollisionDamageData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.collisionDamage', 'Collision Damage')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}>{renderIcon(checkProvided(stepCollisionDamageExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepPetMedical = () => {
    const data = stepPetMedicalMapper.mapToExpenses(props.stepPetMedicalData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.petMedical', 'Pet Medical')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepPetMedicalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepPropertyDamage = () => {
    const data = stepPropertyDamageDataMapper.mapToExpenses(props.stepPropertyDamageData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.propertyDamage', 'Property Damage')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepPropertyDamageExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepTripCancellation = () => {
    const data = stepTripCancellationMapper.mapToExpenses(props.stepTripCancellationData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.tripCancellation', 'Trip Cancellation')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTripCancellationLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderMedicalExpense = () => {
    const data = stepMedicalExpenseMapper.mapToExpenses(props.stepMedicalExpenseData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.medicalExpense', 'Medical Expense')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepMedicalExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTripInterruption = () => {
    const data = stepTripInterruptionDataMapper.mapToExpenses(props.stepTripInterruptionData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.tripInterruption', 'Trip Interruption')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTripInterruptionLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTripDelay = () => {
    const data = stepTripDelayDataMapper.mapToExpenses(props.stepTripDelayData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.tripDelay', 'Trip Delay')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTripDelayLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderMissedConnection = () => {
    const data = stepMissedConnectionDataMapper.mapToExpenses(props.stepMissedConnectionData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.missedConnection', 'Missed Connection')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepMissedConnectionLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderPersonalItem = () => {
    const data = stepPersonalItemDataMapper.mapToExpenses(props.stepPersonalItemData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.baggageAndPersonalEffects', 'Baggage and Personal Effects')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}>{renderIcon(checkProvided(baggagePersonalEffectsLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderMedicalExpenseCF = () => {
    const data = stepMedicalExpenseCFDataMapper.mapToExpenses(props.stepMedicalExpenseCFData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.medicalExpense', 'Medical Expense')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpenseCFLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderMedicalExpenseZurich = () => {
    const data = stepMedicalExpenseZurichDataMapper.mapToExpenses(props.stepMedicalExpenseZurichData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.medicalExpense', 'Medical Expense')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpensesExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderItineraryChange = () => {
    const data = stepItineraryChangeDataMapper.mapToExpenses(props.stepItineraryChangeData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.itineraryChange', 'Itinerary Change')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(itineraryChangeLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderBaggagePersonalEffects = () => {
    const data = stepBaggagePersonalEffectsDataMapper.mapToExpenses(props.stepBaggagePersonalEffectsData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.baggagePersonalEffects', 'Baggage Personal Effects')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(baggagePersonalEffectsLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStepTravelDelay = () => {
    const data = stepTravelDelayDataMapper.mapToExpenses(props.stepTravelDelayData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.travelDelayAndMissedConnections', 'Travel Delay & Missed Connections')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD style={{ textAlign: 'center' }} className="document-table-right document-table-bottom">{renderIcon(checkProvided(stepTravelDelayLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedInsured.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderMedicalAndEvacuation = () => {
    const data = stepMedicalAndEvacuationSCTIDataMapper.mapToExpenses(props.stepMedicalAndEvacuationSCTIData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.medicalAndEvacuation', 'Medical and Evacuation')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalAndEvacuationLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderChangesToYourJourneySCTI = () => {
    const data = stepChangesToYourJourneySCTIDataMapper.mapToExpenses(props.stepChangesToYourJourneySCTIData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.changesToYourJourney', 'Changes to your journey')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepChangesToYourJourneyLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderBaggageAndPersonalItemsSCTI = () => {
    const data = stepBaggageAndPersonalItemsSCTIDataMapper.mapToExpenses(props.stepBaggageAndPersonalItemsSCTIData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.stepWhatHappened.baggageAndPersonalItems', 'Baggage and Personal Items')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepBaggageAndPersonalItemsExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderPersonalAccidentSCTI = () => {
    const data = stepPersonalAccidentSCTIDataMapper.mapToExpenses(props.stepPersonalAccidentSCTIData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.personalAccident', 'Personal Accident')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepPersonalAccidentSCTILookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderRentalVehicleExcessSCTI = () => {
    const data = stepRentalVehicleExcessSCTIDataMapper.mapToExpenses(props.stepRentalVehicleExcessSCTIData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.rentalVehicleExcess', 'Rental vehicle excess')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepRentalVehicleExcessSCTILookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderCashBankCardsTravelDocumentsAndPassports = () => {
    const data = stepCashBankCardsTravelDocumentsAndPassportsDataMapper.mapToExpenses(props.stepCashBankCardsTravelDocumentsAndPassportsData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.cashBankCardsTravelDocumentsAndPassports', 'Cash, bank cards, travel documents and passports')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCashBankCardsTravelDocumentsAndPassportsLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderChangesToYourJourney = () => {
    const data = stepChangesToYourJourneyDataMapper.mapToExpenses(props.stepChangesToYourJourneyData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.changesToYourJourney', 'Changes to your journey')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepChangesToYourJourneyTrawickLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderBaggageAndPersonalItemsStarr = () => {
    const data = stepBaggageAndPersonalItemsStarrDataMapper.mapToExpenses(props.stepBaggageAndPersonalItemsStarrData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.stepWhatHappened.baggageAndPersonalItems', 'Baggage and Personal Items')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepBaggageAndPersonalItemsStarrLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderOtherStarr = () => {
    const data = stepOtherStarrDataMapper.mapToExpenses(props.stepOtherStarrData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.other', 'Other')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepOtherStarrLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderCollisionDamageStarr = () => {
    const data = stepCollisionDamageStarrDataMapper.mapToExpenses(props.stepCollisionDamageStarrData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.DocumentTable.collisionDamage', 'Collision Damage')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepCollisionDamageExpenseLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderMedicalExpensesTugo = () => {
    const data = stepMedicalExpensesTugoDataMapper.mapToExpenses(props.stepMedicalExpensesTugoData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.medicalExpenses', 'Medical Expenses')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepMedicalExpensesTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderOtherTugo = () => {
    const data = stepOtherTugoDataMapper.mapToExpenses(props.stepOtherTugoData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.other', 'Other')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepOtherTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderBaseVictorsMedicalTugo = () => {
    const data = stepBaseVictorsMedicalTugoMapper.mapToExpenses(props.stepBaseVictorsMedicalTugoData);
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.medicalExpenses', 'Medical Expenses')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepBaseVictorsMedicalTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStudentMedicalBenefitsTugo = () => {
    const data = stepStudentMedicalBenefitsTugoMapper.mapToExpenses(props.stepStudentMedicalBenefitsTugoData);
    const title = formatMessage('fastCover.fastCoverWizard.studentMedicalBenefits', 'Student Medical Benefits');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepStudentMedicalBenefitsTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderStandardVTCMedicalBenefitsTugo = () => {
    const data = stepStandardVTCMedicalBenefitsTugoMapper.mapToExpenses(props.stepStandardVTCMedicalBenefitsTugoData);
    const title = formatMessage('fastCover.DocumentTable.medicalBenefits', 'Medical Benefits');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepStandardVTCMedicalBenefitsTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTravellerMedicalBenefitsTugo = () => {
    const data = stepTravellerMedicalBenefitsTugoMapper.mapToExpenses(props.stepTravellerMedicalBenefitsTugoData);
    const title = formatMessage('fastCover.DocumentTable.medicalBenefits', 'Medical Benefits');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepTravellerMedicalBenefitsTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderOptimumMedicalBenefitsTugo = () => {
    const data = stepOptimumMedicalBenefitsTugoMapper.mapToExpenses(props.stepOptimumMedicalBenefitsTugoData);
    const title = data.length > 0 ? (data[0].benefitTitle || formatMessage('fastCover.DocumentTable.medicalBenefits', 'Medical Benefits')) : formatMessage('fastCover.DocumentTable.medicalBenefits', 'Medical Benefits');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepOptimumMedicalBenefitsTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTripCancellationTugo = () => {
    const data = stepTripCancellationTugoMapper.mapToExpenses(props.stepTripCancellationTugoData);
    const title = formatMessage('fastCover.fastCoverWizard.tripCancellation', 'Trip Cancellation');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepTripCancellationTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTripCancellationTravellerTugo = () => {
    const data = stepTripCancellationTravellerTugoMapper.mapToExpenses(props.stepTripCancellationTravellerTugoData);
    const title = formatMessage('fastCover.fastCoverWizard.tripCancellation', 'Trip Cancellation');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepTripCancellationTravellerTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTripInterruptionTravellerTugo = () => {
    const data = stepTripInterruptionTravellerTugoMapper.mapToExpenses(props.stepTripInterruptionTugoData || {});
    const title = formatMessage('fastCover.fastCoverWizard.tripInterruption', 'Trip Interruption');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{title}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}> {renderIcon(checkProvided(stepTripInterruptionTravellerTugoLookup.claimCodeList))}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderTripInterruptionTugo = () => {
    const data = stepTripInterruptionTugoMapper.mapToExpenses(props.stepTripInterruptionTugoData || {});
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && <TD className="align-middle document-table-left document-table-bottom document-table-right" rowSpan={data.length}>{formatMessage('fastCover.fastCoverWizard.tripInterruption', 'Trip Interruption')}</TD>}
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{element.firstname}</TD>
        <TD className={`${idx === data.length - 1 ? 'align-middle text-right document-table-bottom document-table-right' : 'align-middle text-right document-table-right'}`}>{x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}</TD>
        <TD className={`${idx === data.length - 1 ? 'document-table-bottom align-middle document-table-right' : 'align-middle document-table-right'}`}>{x.currency}</TD>
        {idx === 0 && <TD className="text-center align-middle document-table-right document-table-bottom" rowSpan={data.length}>{renderIcon(((stepTripInterruptionTugoLookup.claimCodeList).filter((d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0)).length > 0 && isStepTripInterruptionTugoSelected)}</TD>}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderADAndDTravellerTugo = () => {
    const data = stepADAndDTravellerTugoDataMapper.mapToExpenses(props.stepADAndDBenefitsTugoData || {});
    if (!data || data.length === 0) {
      return null;
    }
    const title = formatMessage('fastCover.fastCoverWizard.adAndD', 'AD&D');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && (
          <TD
            className="align-middle document-table-left document-table-bottom document-table-right"
            rowSpan={data.length}
          >
            {title}
          </TD>
        )}
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {element.firstname}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'align-middle text-right document-table-bottom document-table-right'
            : 'align-middle text-right document-table-right'
            }`}
        >
          {x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {x.currency}
        </TD>
        {idx === 0 && (
          <TD
            className="text-center align-middle document-table-right document-table-bottom"
            rowSpan={data.length}
          >
            {renderIcon(checkProvided(stepADAndDTravellerTugoLookup.claimCodeList))}
          </TD>
        )}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderBaggageAndPersonalItemsTravellerTugo = () => {
    const data = stepBaggageAndPersonalItemsTravellerTugoDataMapper.mapToExpenses(props.stepBaggageAndPersonalItemsTravellerTugoData || {});
    if (!data || data.length === 0) {
      return null;
    }
    const title = formatMessage('fastCover.fastCoverWizard.baggageAndPersonalItems', 'Baggage and personal items');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && (
          <TD
            className="align-middle document-table-left document-table-bottom document-table-right"
            rowSpan={data.length}
          >
            {title}
          </TD>
        )}
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {element.firstname}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'align-middle text-right document-table-bottom document-table-right'
            : 'align-middle text-right document-table-right'
            }`}
        >
          {x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {x.currency}
        </TD>
        {idx === 0 && (
          <TD
            className="text-center align-middle document-table-right document-table-bottom"
            rowSpan={data.length}
          >
            {renderIcon(checkProvided(stepBaggageAndPersonalItemsTravellerTugoLookup.claimCodeList))}
          </TD>
        )}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderRentalCarProtectionTravellerTugo = () => {
    const data = stepRentalCarProtectionTravellerTugoDataMapper.mapToExpenses(props.stepRentalCarProtectionTravellerTugoData || {});
    if (!data || data.length === 0) {
      return null;
    }
    const title = formatMessage('fastCover.fastCoverWizard.rentalCarProtection', 'Rental Car Protection');
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && (
          <TD
            className="align-middle document-table-left document-table-bottom document-table-right"
            rowSpan={data.length}
          >
            {title}
          </TD>
        )}
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {element.firstname}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'align-middle text-right document-table-bottom document-table-right'
            : 'align-middle text-right document-table-right'
            }`}
        >
          {x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {x.currency}
        </TD>
        {idx === 0 && (
          <TD
            className="text-center align-middle document-table-right document-table-bottom"
            rowSpan={data.length}
          >
            {renderIcon(checkProvided(stepRentalCarProtectionTravellerTugoLookup.claimCodeList))}
          </TD>
        )}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  const renderADAndDTugo = () => {
    const data = stepADAndDTugoDataMapper.mapToExpenses(props.stepADAndDBenefitsTugoData || {});
    if (!data || data.length === 0) {
      return null;
    }
    const renderRow = (element, x, idx) => (
      <TR key={idx} noHover>
        {idx === 0 && (
          <TD
            className="align-middle document-table-left document-table-bottom document-table-right"
            rowSpan={data.length}
          >
            {formatMessage('fastCover.fastCoverWizard.adAndDBenefits', 'AD&D')}
          </TD>
        )}
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {element.firstname}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'align-middle text-right document-table-bottom document-table-right'
            : 'align-middle text-right document-table-right'
            }`}
        >
          {x.clientCost ? (+x.clientCost).toLocaleString('en') : 0}
        </TD>
        <TD
          className={`${idx === data.length - 1
            ? 'document-table-bottom align-middle document-table-right'
            : 'align-middle document-table-right'
            }`}
        >
          {x.currency}
        </TD>
        {idx === 0 && (
          <TD
            className="text-center align-middle document-table-right document-table-bottom"
            rowSpan={data.length}
          >
            {renderIcon(
              ((stepADAndDTugoLookup.claimCodeList).filter(
                (d) => (attachDocuments.filter((c) => c.benefitCode === d)).length > 0
              ).length > 0) && isStepADAndDTugoSelected
            )}
          </TD>
        )}
      </TR>
    );
    return selectedClaimForList.map((element) => data.map((x, idx) => renderRow(element, x, idx)));
  };

  return (
    <Table>
      <thead>
        <tr>
          <TH className="document-table-top document-table-left document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            {formatMessage('fastCover.DocumentTable.Benefit', 'Benefit')}
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            {formatMessage('fastCover.DocumentTable.member', 'Member')}
          </TH>
          <TH className="text-right document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            {formatMessage('fastCover.DocumentTable.Amount', 'Amount Claimed')}
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            {formatMessage('fastCover.DocumentTable.currency', 'Currency')}
          </TH>
          <TH className="document-table-top document-table-right align-middle" color={'#000000'} backgroundColor={'#fff'}>
            {formatMessage('fastCover.DocumentTable.provided', 'Documents Provided')}
          </TH>
        </tr>
      </thead>
      <tbody>
        {isStepOverseasMedicalSelected && renderStepOverseasMedical()}
        {isStepPersonalItemsSelected && renderStepPersonalItems()}
        {isStepCancellationAdditionalSelected && renderStepCancellationAdditional()}
        {isStepRentalVehicleSelected && !!stepRentalVehicleExpenseLookup.areYouClaimingForRentalVehicleExcess.claimCode && <TR noHover>
          <TD className="align-middle document-table-left  document-table-bottom document-table-right">{formatMessage('fastCover.DocumentTable.rentalVehicle', 'Rental Vehicle')}</TD>
          <TD className="document-table-bottom align-middle document-table-right" >{props.stepRentalVehicleData.description}</TD>
          <TD className="document-table-bottom text-right align-middle  document-table-right">{(+stepRentalVehicleAmount).toLocaleString('en')}</TD>
          <TD className="document-table-bottom align-middle document-table-right">{props.stepRentalVehicleData.amountClaimedCurrency}</TD>
          <TD style={{ textAlign: 'center' }} className="document-table-right document-table-top"> {renderIcon(checkProvided(stepRentalVehicleExpenseLookup.claimCodeList))}</TD>
        </TR>}
        {isStepOtherSelected && renderStepOther()}
        {isStepTripCancellationAndTripInterruptionSelected && renderStepTripCancellationAndTripInterruption()}
        {isStepBaggageAndPersonalItemsSelected && renderStepBaggageAndPersonalItems()}
        {isStepMedicalExpensesSelected && renderStepMedicalExpenses()}
        {isStepCollisionDamageSelected && renderStepCollisionDamage()}
        {isStepPetMedicalSelected && renderStepPetMedical()}
        {isStepPropertyDamageSelected && renderStepPropertyDamage()}
        {isStepTripCancellationSelected && renderStepTripCancellation()}
        {isStepMedicalExpenseSelected && renderMedicalExpense()}
        {isStepTripInterruptionSelected && renderTripInterruption()}
        {isStepTripDelaySelected && renderTripDelay()}
        {isStepMissedConnectionSelected && renderMissedConnection()}
        {isStepPersonalItemSelected && renderPersonalItem()}
        {isStepMedicalExpenseCFSelected && renderMedicalExpenseCF()}
        {isStepItineraryChangeSelected && renderItineraryChange()}
        {isStepBaggagePersonalEffectsSelected && renderBaggagePersonalEffects()}
        {isStepTravelDelaySelected && renderStepTravelDelay()}
        {isStepMedicalExpenseZurichSelected && renderMedicalExpenseZurich()}
        {isStepMedicalAndEvacuationSelected && renderMedicalAndEvacuation()}
        {isStepChangesToYourJourneySCTISelected && renderChangesToYourJourneySCTI()}
        {isStepBaggageAndPersonalItemsSCTISelected && renderBaggageAndPersonalItemsSCTI()}
        {isStepPersonalAccidentSCTISelected && renderPersonalAccidentSCTI()}
        {isStepRentalVehicleExcessSCTISelected && renderRentalVehicleExcessSCTI()}
        {isStepCashBankCardsTravelDocumentsAndPassportsSelected && renderCashBankCardsTravelDocumentsAndPassports()}
        {isStepChangesToYourJourneySelected && renderChangesToYourJourney()}
        {isStepBaggageAndPersonalItemsStarrSelected && renderBaggageAndPersonalItemsStarr()}
        {isStepOtherStarrSelected && renderOtherStarr()}
        {isStepCollisionDamageStarrSelected && renderCollisionDamageStarr()}
        {isStepMedicalExpensesTugoSelected && renderMedicalExpensesTugo()}
        {isStepOtherTugoSelected && renderOtherTugo()}
        {isStepBaseVictorsMedicalTugoSelected && renderBaseVictorsMedicalTugo()}
        {isStepStudentMedicalBenefitsTugoSelected && renderStudentMedicalBenefitsTugo()}
        {isStepStandardVTCMedicalBenefitsTugoSelected && renderStandardVTCMedicalBenefitsTugo()}
        {isStepTravellerMedicalBenefitsTugoSelected && renderTravellerMedicalBenefitsTugo()}
        {isStepOptimumMedicalBenefitsTugoSelected && renderOptimumMedicalBenefitsTugo()}
        {isStepTripCancellationTugoSelected && renderTripCancellationTugo()}
        {isStepTripCancellationTravellerTugoSelected && renderTripCancellationTravellerTugo()}
        {isStepTripInterruptionTravellerTugoSelected && renderTripInterruptionTravellerTugo()}
        {isStepTripInterruptionTugoSelected && renderTripInterruptionTugo()}
        {isStepADAndDTugoSelected && renderADAndDTugo()}
        {isStepADAndDTravellerTugoSelected && renderADAndDTravellerTugo()}
        {isStepBaggageAndPersonalItemsTravellerTugoSelected && renderBaggageAndPersonalItemsTravellerTugo()}
        {isStepRentalCarProtectionTravellerTugoSelected && renderRentalCarProtectionTravellerTugo()}
      </tbody>
    </Table>
  );
};
export default DocumentTableMultiInsureds;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/components/DocumentTableMultiInsureds/index.js